module.exports = __webpack_public_path__ + "img/btn_LOW_normal.c8796d04.png";